(function ($, Drupal, drupalSettings, once) {

  Drupal.behaviors.imageHotSpotAllContent = {
    attach(context) {

      once(
          'hotspots-show-all-content',
          '.paragraph--type--image-hotspots.show-all-content',
          context
      ).forEach(function (wrapper) {

        const hotspotParagraphs = wrapper.querySelectorAll(
            '.paragraph--type--image-hotspot-item-desktop, .paragraph--type--image-hotspot-item-mobile'
        );

        if (!hotspotParagraphs.length) {
          return;
        }

        hotspotParagraphs.forEach(function (hotspotParagraph) {

          const paragraphId =
              hotspotParagraph.dataset.hotspotParagraph;

          console.log(paragraphId);

          const settings =
              drupalSettings.imageHotspotAgent?.paragraphs?.[paragraphId];

          if (!settings?.hotspots?.length) {
            return;
          }

          const titleContainers =
              hotspotParagraph.querySelectorAll('.title-container');

          if (!titleContainers.length) {
            return;
          }

          titleContainers.forEach((container) => {

            if (container.querySelector('.all-hotspots-content')) {
              return;
            }

            const contentWrapper = document.createElement('div');
            contentWrapper.className = 'all-hotspots-content';

            settings.hotspots.forEach(function (hotspot) {

              const item = document.createElement('div');

              item.className = 'all-hotspots-content__item';
              item.dataset.hotspotId = hotspot.id;

              item.innerHTML = `
                <h4 class="all-hotspots-content__title">
                  ${hotspot.title}
                </h4>

                <div class="all-hotspots-content__description">
                  ${hotspot.description || ''}
                </div>
              `;

              contentWrapper.appendChild(item);

            });

            container.appendChild(contentWrapper);

          });

        });

      });

      /**
       * Click on hotspot dot
       */
      $(document)
      .off(
          'click.hotspotDot',
          '.paragraph--type--image-hotspots.show-all-content .agent-hotspot-base__dot'
      )
      .on(
          'click.hotspotDot',
          '.paragraph--type--image-hotspots.show-all-content .agent-hotspot-base__dot',
          function () {

            const $wrapper = $(this).closest(
                '.paragraph--type--image-hotspots'
            );

            const hotspotId = $(this).data('hotspot-id');

            $wrapper
            .find('.agent-hotspot-base__dot')
            .removeClass('active');

            $(this).addClass('active');

            const $target = $wrapper.find(
                '.all-hotspots-content__item[data-hotspot-id="' +
                hotspotId +
                '"]'
            );

            if (!$target.length) {
              return;
            }

            $wrapper
            .find('.all-hotspots-content__item')
            .removeClass('active');

            $target.addClass('active');

            $target[0].scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

            $target[1].scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

          }
      );

      /**
       * Click on content
       */
      $(document)
      .off(
          'click.hotspotContent',
          '.paragraph--type--image-hotspots.show-all-content .all-hotspots-content__item'
      )
      .on(
          'click.hotspotContent',
          '.paragraph--type--image-hotspots.show-all-content .all-hotspots-content__item',
          function () {

            const $wrapper = $(this).closest(
                '.paragraph--type--image-hotspots'
            );

            const hotspotId = $(this).data('hotspot-id');

            $wrapper
            .find('.all-hotspots-content__item')
            .removeClass('active');

            $(this).addClass('active');

            const $dot = $wrapper.find(
                '.agent-hotspot-base__dot[data-hotspot-id="' +
                hotspotId +
                '"]'
            );

            if (!$dot.length) {
              return;
            }

            $wrapper
            .find('.agent-hotspot-base__dot')
            .removeClass('active');

            $dot.addClass('active');

          }
      );

    }
  };

})(jQuery, Drupal, drupalSettings, once);